export default "__VITE_ASSET__BIFW$48$__"